export default "__VITE_ASSET__BJTLgxg5__"